import * as React from 'react';

const DonutChart = ({ percentage }) => {
  return (
    <svg
      width='180'
      height='132'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M166.275 128c6.212-11.725 9.725-25.061 9.725-39.206C176 41.964 137.496 4 90 4S4 41.964 4 88.794C4 102.94 7.513 116.275 13.725 128'
        stroke={`${!percentage ? '#EECFD2' : '#FF0037'}`}
        pathLength='100'
        strokeWidth='8'
        strokeDasharray={`${percentage} 100`}
        strokeDashoffset='0'
        strokeLinecap='round'
      ></path>

      <path
        d='M166.275 128c6.212-11.725 9.725-25.061 9.725-39.206C176 41.964 137.496 4 90 4S4 41.964 4 88.794C4 102.94 7.513 116.275 13.725 128'
        stroke='#EECFD2'
        pathLength='100'
        strokeWidth='8'
        strokeDasharray={`0 ${percentage} 100`}
        strokeDashoffset='0'
        strokeLinecap='butt'
      />
    </svg>
  );
};

export default DonutChart;
